import Layout from '../../components/feature/Layout';
import { useSEO, generateWebPageSchema } from '../../utils/seo';

export default function PrivacyPage() {
  // SEO設定
  useSEO({
    title: 'プライバシーポリシー｜キョウコレ',
    description: 'キョウコレのプライバシーポリシーです。個人情報の取り扱いについて説明しています。',
    keywords: 'プライバシーポリシー,個人情報保護,キョウコレ',
    canonical: (import.meta.env.VITE_SITE_URL || 'https://example.com') + '/privacy',
    jsonLd: generateWebPageSchema(
      'プライバシーポリシー｜キョウコレ',
      'キョウコレのプライバシーポリシーです。個人情報の取り扱いについて説明しています。',
      '/privacy'
    ),
  });

  return (
    <Layout>
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        {/* ページタイトル */}
        <h1 className="text-3xl font-bold text-gray-900 mb-2">
          プライバシーポリシー
        </h1>
        <p className="text-sm text-gray-600 mb-8">
          最終更新日：2025年1月
        </p>

        {/* 前文 */}
        <div className="mb-8 text-gray-700 leading-relaxed">
          <p>
            キョウコレ（以下「当サイト」といいます）は、ユーザーの個人情報の取り扱いについて、以下のとおりプライバシーポリシー（以下「本ポリシー」といいます）を定めます。
          </p>
        </div>

        {/* 各条項 */}
        <div className="space-y-8">
          {/* 第1条 */}
          <section>
            <h2 className="text-xl font-bold text-gray-900 mb-3 pb-2 border-b border-gray-200">
              第1条（個人情報）
            </h2>
            <div className="text-gray-700 leading-relaxed space-y-2">
              <p>
                「個人情報」とは、個人情報保護法にいう「個人情報」を指すものとし、生存する個人に関する情報であって、当該情報に含まれる氏名、メールアドレス、その他の記述等により特定の個人を識別できる情報を指します。
              </p>
            </div>
          </section>

          {/* 第2条 */}
          <section>
            <h2 className="text-xl font-bold text-gray-900 mb-3 pb-2 border-b border-gray-200">
              第2条（個人情報の収集方法）
            </h2>
            <div className="text-gray-700 leading-relaxed space-y-2">
              <p>
                当サイトは、ユーザーが利用登録をする際に、以下の個人情報をお尋ねすることがあります。
              </p>
              <ul className="list-disc list-inside ml-4 space-y-1">
                <li>メールアドレス</li>
                <li>ニックネーム（任意）</li>
                <li>投稿者区分（教員・居場所スタッフ・ボランティア・その他）</li>
              </ul>
              <p className="mt-3">
                また、フィードバックフォームを通じて、以下の情報を収集することがあります。
              </p>
              <ul className="list-disc list-inside ml-4 space-y-1">
                <li>お名前（任意）</li>
                <li>メールアドレス（任意）</li>
                <li>フィードバック内容</li>
              </ul>
            </div>
          </section>

          {/* 第3条 */}
          <section>
            <h2 className="text-xl font-bold text-gray-900 mb-3 pb-2 border-b border-gray-200">
              第3条（個人情報を収集・利用する目的）
            </h2>
            <div className="text-gray-700 leading-relaxed space-y-2">
              <p>
                当サイトが個人情報を収集・利用する目的は、以下のとおりです。
              </p>
              <ul className="list-disc list-inside ml-4 space-y-1">
                <li>本サービスの提供・運営のため</li>
                <li>ユーザーからのお問い合わせに回答するため</li>
                <li>ユーザーが利用中のサービスの新機能、更新情報、キャンペーン等の案内のメールを送付するため</li>
                <li>メンテナンス、重要なお知らせなど必要に応じたご連絡のため</li>
                <li>利用規約に違反したユーザーや、不正・不当な目的でサービスを利用しようとするユーザーの特定をし、ご利用をお断りするため</li>
                <li>ユーザーにご自身の登録情報の閲覧や変更、削除、ご利用状況の閲覧を行っていただくため</li>
                <li>本サービスの改善・新サービスの開発のため</li>
                <li>本サービスに関する統計データを作成するため</li>
                <li>上記の利用目的に付随する目的</li>
              </ul>
            </div>
          </section>

          {/* 第4条 */}
          <section>
            <h2 className="text-xl font-bold text-gray-900 mb-3 pb-2 border-b border-gray-200">
              第4条（利用目的の変更）
            </h2>
            <div className="text-gray-700 leading-relaxed space-y-2">
              <p>
                1. 当サイトは、利用目的が変更前と関連性を有すると合理的に認められる場合に限り、個人情報の利用目的を変更するものとします。
              </p>
              <p>
                2. 利用目的の変更を行った場合には、変更後の目的について、当サイト所定の方法により、ユーザーに通知し、または本ウェブサイト上に公表するものとします。
              </p>
            </div>
          </section>

          {/* 第5条 */}
          <section>
            <h2 className="text-xl font-bold text-gray-900 mb-3 pb-2 border-b border-gray-200">
              第5条（個人情報の第三者提供）
            </h2>
            <div className="text-gray-700 leading-relaxed space-y-2">
              <p>
                1. 当サイトは、次に掲げる場合を除いて、あらかじめユーザーの同意を得ることなく、第三者に個人情報を提供することはありません。ただし、個人情報保護法その他の法令で認められる場合を除きます。
              </p>
              <ul className="list-disc list-inside ml-4 space-y-1">
                <li>人の生命、身体または財産の保護のために必要がある場合であって、本人の同意を得ることが困難であるとき</li>
                <li>公衆衛生の向上または児童の健全な育成の推進のために特に必要がある場合であって、本人の同意を得ることが困難であるとき</li>
                <li>国の機関もしくは地方公共団体またはその委託を受けた者が法令の定める事務を遂行することに対して協力する必要がある場合であって、本人の同意を得ることにより当該事務の遂行に支障を及ぼすおそれがあるとき</li>
              </ul>
              <p className="mt-3">
                2. 前項の定めにかかわらず、次に掲げる場合には、当該情報の提供先は第三者に該当しないものとします。
              </p>
              <ul className="list-disc list-inside ml-4 space-y-1">
                <li>当サイトが利用目的の達成に必要な範囲内において個人情報の取扱いの全部または一部を委託する場合</li>
                <li>合併その他の事由による事業の承継に伴って個人情報が提供される場合</li>
              </ul>
            </div>
          </section>

          {/* 第6条 */}
          <section>
            <h2 className="text-xl font-bold text-gray-900 mb-3 pb-2 border-b border-gray-200">
              第6条（個人情報の開示）
            </h2>
            <div className="text-gray-700 leading-relaxed space-y-2">
              <p>
                1. 当サイトは、本人から個人情報の開示を求められたときは、本人に対し、遅滞なくこれを開示します。ただし、開示することにより次のいずれかに該当する場合は、その全部または一部を開示しないこともあり、開示しない決定をした場合には、その旨を遅滞なく通知します。
              </p>
              <ul className="list-disc list-inside ml-4 space-y-1">
                <li>本人または第三者の生命、身体、財産その他の権利利益を害するおそれがある場合</li>
                <li>当サイトの業務の適正な実施に著しい支障を及ぼすおそれがある場合</li>
                <li>その他法令に違反することとなる場合</li>
              </ul>
              <p className="mt-3">
                2. 前項の定めにかかわらず、履歴情報および特性情報などの個人情報以外の情報については、原則として開示いたしません。
              </p>
            </div>
          </section>

          {/* 第7条 */}
          <section>
            <h2 className="text-xl font-bold text-gray-900 mb-3 pb-2 border-b border-gray-200">
              第7条（個人情報の訂正および削除）
            </h2>
            <div className="text-gray-700 leading-relaxed space-y-2">
              <p>
                1. ユーザーは、当サイトの保有する自己の個人情報が誤った情報である場合には、当サイトが定める手続きにより、当サイトに対して個人情報の訂正、追加または削除（以下「訂正等」といいます）を請求することができます。
              </p>
              <p>
                2. 当サイトは、ユーザーから前項の請求を受けてその請求に応じる必要があると判断した場合には、遅滞なく、当該個人情報の訂正等を行うものとします。
              </p>
              <p>
                3. 当サイトは、前項の規定に基づき訂正等を行った場合、または訂正等を行わない旨の決定をしたときは遅滞なく、これをユーザーに通知します。
              </p>
            </div>
          </section>

          {/* 第8条 */}
          <section>
            <h2 className="text-xl font-bold text-gray-900 mb-3 pb-2 border-b border-gray-200">
              第8条（個人情報の利用停止等）
            </h2>
            <div className="text-gray-700 leading-relaxed space-y-2">
              <p>
                1. 当サイトは、本人から、個人情報が、利用目的の範囲を超えて取り扱われているという理由、または不正の手段により取得されたものであるという理由により、その利用の停止または消去（以下「利用停止等」といいます）を求められた場合には、遅滞なく必要な調査を行います。
              </p>
              <p>
                2. 前項の調査結果に基づき、その請求に応じる必要があると判断した場合には、遅滞なく、当該個人情報の利用停止等を行います。
              </p>
              <p>
                3. 当サイトは、前項の規定に基づき利用停止等を行った場合、または利用停止等を行わない旨の決定をしたときは、遅滞なく、これをユーザーに通知します。
              </p>
            </div>
          </section>

          {/* 第9条 */}
          <section>
            <h2 className="text-xl font-bold text-gray-900 mb-3 pb-2 border-b border-gray-200">
              第9条（Cookie（クッキー）その他の技術の利用）
            </h2>
            <div className="text-gray-700 leading-relaxed space-y-2">
              <p>
                1. 当サイトは、ユーザーによりよいサービスを提供するため、Cookie等の技術を使用することがあります。これらの技術は、当サイトがユーザーのアクセス状況を把握するために使用されます。
              </p>
              <p>
                2. ユーザーは、Webブラウザの設定により、Cookieの受け取りを拒否することができます。ただし、Cookieの受け取りを拒否した場合、本サービスの一部の機能が利用できなくなることがあります。
              </p>
              <p>
                3. 当サイトは、本サービスの利用状況を把握するため、Google Analyticsなどのアクセス解析ツールを使用することがあります。これらのツールは、Cookieを使用してユーザーの情報を収集します。収集される情報は匿名で収集されており、個人を特定するものではありません。
              </p>
            </div>
          </section>

          {/* 第10条 */}
          <section>
            <h2 className="text-xl font-bold text-gray-900 mb-3 pb-2 border-b border-gray-200">
              第10条（外部サービスとの連携）
            </h2>
            <div className="text-gray-700 leading-relaxed space-y-2">
              <p>
                1. 本サービスは、認証基盤としてSupabaseを使用しています。ユーザーのメールアドレスおよびパスワードは、Supabaseのセキュアな環境で管理されます。
              </p>
              <p>
                2. フィードバックフォームは、Readdy.aiのフォームサービスを使用しています。フォームから送信された情報は、Readdy.aiのサーバーに保存されます。
              </p>
              <p>
                3. 本サービスは、オンライン学習支援プラットフォーム「Boratasu（ボラタス）」へのリンクを含みますが、Boratasuは当サイトと同一の運営主体によって提供されています。Boratasuで収集される個人情報については、Boratasu独自のプライバシーポリシーが適用されます。
              </p>
            </div>
          </section>

          {/* 第11条 */}
          <section>
            <h2 className="text-xl font-bold text-gray-900 mb-3 pb-2 border-b border-gray-200">
              第11条（プライバシーポリシーの変更）
            </h2>
            <div className="text-gray-700 leading-relaxed space-y-2">
              <p>
                1. 本ポリシーの内容は、法令その他本ポリシーに別段の定めのある事項を除いて、ユーザーに通知することなく、変更することができるものとします。
              </p>
              <p>
                2. 当サイトが別途定める場合を除いて、変更後のプライバシーポリシーは、本ウェブサイトに掲載したときから効力を生じるものとします。
              </p>
            </div>
          </section>

          {/* 第12条 */}
          <section>
            <h2 className="text-xl font-bold text-gray-900 mb-3 pb-2 border-b border-gray-200">
              第12条（未成年のユーザーの個人情報）
            </h2>
            <div className="text-gray-700 leading-relaxed space-y-2">
              <p>
                1. 当サイトは、こども・若者の学びや居場所に関する情報を取り扱う性質上、未成年のユーザーによる利用が想定されることを踏まえ、個人情報の適切な保護に努めます。
              </p>
              <p>
                2. 未成年のユーザーが本サービスを利用する場合には、可能な範囲で保護者や支援者の方にも本ポリシーの内容をご確認いただくようお願いいたします。
              </p>
              <p>
                3. 保護者または法定代理人から、未成年のユーザーに関する個人情報の開示・訂正・利用停止等のお申し出があった場合には、本人との関係性を確認のうえ、法令に従って適切に対応します。
              </p>
            </div>
          </section>

          {/* 第13条 */}
          <section>
            <h2 className="text-xl font-bold text-gray-900 mb-3 pb-2 border-b border-gray-200">
              第13条（お問い合わせ窓口）
            </h2>
            <div className="text-gray-700 leading-relaxed space-y-2">
              <p>
                本ポリシーに関するお問い合わせ、個人情報の開示・訂正・利用停止等のご請求は、下記の窓口までお願いいたします。
              </p>
              <div className="mt-4 p-4 bg-gray-50 rounded-lg space-y-2">
                <p>
                  <strong>事業者名：</strong>［キョウコレ運営主体の正式名称（例：財恩工房／NPO法人エンカレッジ など）］
                </p>
                <p>
                  <strong>メールアドレス：</strong>［お問い合わせ用メールアドレス］
                </p>
                <p>
                  <strong>お問い合わせフォーム：</strong>
                  <a href="/feedback" className="text-teal-600 hover:text-teal-700 underline cursor-pointer ml-1">
                    フィードバックフォーム
                  </a>
                </p>
              </div>
            </div>
          </section>
        </div>

        {/* フッター */}
        <div className="mt-12 pt-8 border-t border-gray-200 text-center">
          <p className="text-sm text-gray-600">
            本ポリシーについてご不明な点がございましたら、
            <a href="/feedback" className="text-teal-600 hover:text-teal-700 underline cursor-pointer">
              フィードバックフォーム
            </a>
            よりお問い合わせください。
          </p>
        </div>
      </div>
    </Layout>
  );
}
